import { InventoryRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { CreateNewInventoryType } from "@utilities/types";

export const inventoryServices =  {

    newInventory: async (newInventory: Partial<CreateNewInventoryType>)=> {
        return await fetchRequest({
            route: InventoryRoutesEnum.INVENTORY_NEW,
            method: "POST",
            data: newInventory
        });
    },

    getAllOrganisationInventory: async (organisationID: string)=> {
        return await fetchRequest({
            route: `${InventoryRoutesEnum.INVENTORY_GET_ALL}/${organisationID}`,
            method: "GET",
        });
    },

};
